import { TYPO } from "styles/Typo";
import { useCollectByStock } from "utils/clientAPIs/discuss";
import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import moment from "moment-timezone";
import Button from "components/common/buttons/buttons";
import { useRecoilState } from "recoil";
import { searchModalState } from "states/SearchModalState";
import SearchModal from "../../Detail/SearchModal";
import SkeletonBlock from "components/skeleton";
import React from "react";
import ReportThumb from "../../components/ReportThumb";
import { getStockLogo } from "utils/image";
import { useHandleImageErrorVer2 } from "utils/useHandleImageError";
import { trackPageAction } from "lib/analytics/core/actions";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";
import { TrackedLink } from "lib/analytics/react/link";
import { KOREA } from "utils/constant/ITME_INFO";
const ListTemp = React.memo(
  ({
    agenda,
    animation,
    router,
    index,
  }: {
    agenda: any;
    animation: string;
    router: any;
    index: number;
  }) => {
    return (
      <TrackedListItem
        itemData={{
          kind: "report",
          report_id: agenda.id,
          rank: index + 1,
        }}
        href={`/discuss/${
          agenda.url_slug ? `${agenda.url_slug}-${agenda.id}` : agenda.id
        }`}
        data-gtm-id={`feed-collect-by-stock-list-item `}
        className={`group cursor-pointer flex gap-4 w-full justify-between flex-start items-start ${
          animation === "fadeOut"
            ? "fade-out-strategy"
            : animation === "fadeIn"
            ? "fade-in-strategy"
            : ""
        }`}
        // onClick={() => {
        //   router.push(
        //     `/discuss/${
        //       agenda.url_slug ? `${agenda.url_slug}-${agenda.id}` : agenda.id
        //     }`
        //   );
        // }}
      >
        <div className="flex flex-col gap-2">
          <span
            className={`${TYPO.TYPO5_SB} text-gray80  w-fit line-clamp-2 group-hover:text-blue40`}
          >
            {agenda.title}
          </span>
          <span className={`${TYPO.TYPO7_RG} text-gray40  w-fit`}>
            {moment(agenda.issue_at).format("YYYY.M.D")}
          </span>
        </div>

        <ReportThumb
          data={agenda}
          width={85}
          className=" rounded-[10px] shrink-0  w-[85px]"
        />
      </TrackedListItem>
    );
  }
);
ListTemp.displayName = "ListTemp";

function CollectByStock() {
  const [searchModal, setSearchModal] = useRecoilState(searchModalState);
  const { getStockLogoSafe, onError } = useHandleImageErrorVer2();
  const [data, isLoading] = useCollectByStock();
  const { t } = useTranslation("main");

  const [activeStock, setActiveStock] = useState<number>(0);
  const router = useRouter();
  const [animation, setAnimation] = useState<string>("");
  const [intervalTimer, setTimer] = useState<any>(null);
  const [timeoutTimer, setTimeoutTimer] = useState<any>(null);
  const refs = useRef<any[]>([]);

  const [widths, setWidths] = useState<number[]>([]);
  useEffect(() => {
    if (!data) return;
    // refs 배열 길이 맞추기
    refs.current = refs.current.slice(0, data.length);

    // mount 후 한 번만 width 측정
    setTimeout(() => {
      const measured = refs.current.map((el: any) => el?.clientWidth || 0);
      setWidths(measured);
    }, 100);
  }, [data]);

  const stopInterval = () => {
    clearTimeout(intervalTimer);
  };
  const clearTimeoutTimer = () => {
    clearTimeout(timeoutTimer);
  };

  const startInterval = () => {
    let timer = setInterval(() => {
      setAnimation("fadeOut");
      clearTimeoutTimer();
      let outTimer = setTimeout(() => {
        setAnimation("fadeIn");
        setActiveStock((prev) => (prev + 1) % data.length);
      }, 200);
      setTimeoutTimer(outTimer);
    }, 3000);
    setTimer(timer);
  };

  useEffect(() => {
    if (!data) return;
    startInterval();
    return () => {
      stopInterval();
      clearTimeoutTimer();
    };
  }, [data]);

  if (isLoading) {
    return (
      <div className="px-5  flex flex-col gap-9 pb-[90px]">
        <SkeletonBlock width={"100%"} height={25} />
        <div className="flex flex-col gap-3">
          <SkeletonBlock width={"100%"} height={68} />
          <SkeletonBlock width={"100%"} height={68} />
          <SkeletonBlock width={"100%"} height={68} />
          <SkeletonBlock width={"100%"} height={68} />
          <SkeletonBlock width={"100%"} height={68} />
          <SkeletonBlock width={"100%"} height={68} />
        </div>
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="  flex flex-col gap-9 pb-[90px]">
      <p className={`${TYPO.TYPO3_SB} text-gray90 text-center px-5 `}>
        {t("collectByStock")}
      </p>
      <div className="flex flex-col gap-4">
        {/** header */}

        <div className="px-5 overflow-x-auto scroll">
          <div className="flex gap-3   shrink-0">
            {data.map((item: any, index: number) => {
              return (
                <div
                  key={index}
                  data-gtm-id={`feed-collect-by-stock-list`}
                  className="flex gap-2 items-center overflow-hidden w-fit shrink-0"
                >
                  <div
                    className={`w-[40px] h-[40px] rounded-full overflow-hidden flex items-center justify-center shrink-0 cursor-pointer ${
                      activeStock === index ? "border-[2px] border-blue40" : ""
                    } `}
                    onClick={() => {
                      trackPageAction("filter_feed_stock");
                      stopInterval();
                      setAnimation("fadeOut");
                      clearTimeoutTimer();
                      let outTimer = setTimeout(() => {
                        setAnimation("fadeIn");
                        setActiveStock(index);
                        startInterval();
                      }, 200);
                      setTimeoutTimer(outTimer);
                    }}
                  >
                    <Image
                      src={getStockLogoSafe(item.ITEM_CD_DL)}
                      alt={item.ITEM_KR_NM}
                      width={40}
                      height={40}
                      loading="lazy"
                      onError={() => onError(item.ITEM_CD_DL)}
                    />
                  </div>
                  <div
                    className="relative  overflow-hidden w-fit  "
                    style={{
                      width:
                        activeStock === index
                          ? widths[index] || "120px"
                          : "0px",
                      transform:
                        activeStock === index ? "scale(1)" : "scale(0.8)",
                      opacity: activeStock === index ? 1 : 0,
                      transition: "all 0.6s ease-in-out",
                    }}
                  >
                    <div
                      className="flex flex-col h-[42.5px] w-fit "
                      ref={(el: HTMLDivElement | null) => {
                        (refs as any).current[index] = el;
                      }}
                    >
                      <span
                        className={`${TYPO.TYPO7_MD} text-gray80 whitespace-nowrap w-fit`}
                      >
                        {router.locale === "ko"
                          ? item.ITEM_KR_NM
                          : item.ITEM_ENG_NM || item.ITEM_KR_NM}
                      </span>
                      <span
                        className={`${TYPO.TYPO8_RG} text-gray50 whitespace-nowrap w-fit`}
                      >
                        {t("reportCount", { count: item?.reportCount })}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <TrackedList
          listId="feed_reports_by_stock_list"
          totalCount={data.length}
        >
          <div className="flex flex-col py-2 gap-[40px] w-full px-5 ">
            {data[activeStock]?.agendas?.map((agenda: any, index: number) => {
              return (
                <ListTemp
                  agenda={agenda}
                  key={index}
                  animation={animation}
                  router={router}
                  index={index}
                />
              );
            })}
          </div>
        </TrackedList>

        <div className="flex items-center justify-center">
          <TrackedLink
            href={`/search?query=${data?.[activeStock]?.ITEM_KR_NM}`}
            asTrace={true}
            itemspec={{
              kind: "section_nav",
              section_id: "feed_by_stock",
              nav_key: "feed_navbtn_go_stock_search",
            }}
            fromListId="feed_reports_by_stock_list"
          >
            <Button
              type="tertiary"
              text={t("viewAll")}
              size="lg"
              // clickHandler={() => {
              //   router.push(`/search?query=${data?.[activeStock]?.ITEM_KR_NM}`);
              // }}
            />
          </TrackedLink>
        </div>
      </div>
      {searchModal.modalOpen && <SearchModal setSearchModal={setSearchModal} />}
    </div>
  );
}

export default CollectByStock;
